// Aria orbital logo mark — cream/gold palette aligned with landing page
const LogoMark = ({ size = 32, className = "", spin = true }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    className={`${spin ? "aria-spin" : ""} ${className}`.trim()}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id={`aria-g1-${size}`} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#f5c842" />
        <stop offset="1" stopColor="#d4a017" />
      </linearGradient>
      <linearGradient id={`aria-g2-${size}`} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#d4a017" />
        <stop offset="1" stopColor="#a07010" />
      </linearGradient>
      <linearGradient id={`aria-g3-${size}`} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#a07010" />
        <stop offset="1" stopColor="#6e4a08" />
      </linearGradient>
      <radialGradient id={`aria-core-${size}`} cx="0.35" cy="0.35" r="0.65">
        <stop offset="0" stopColor="#f5c842" />
        <stop offset="0.55" stopColor="#d4a017" />
        <stop offset="1" stopColor="#a07010" />
      </radialGradient>
    </defs>

    {/* Static core — the "planet" */}
    <g>
      <circle cx="32" cy="32" r="6.5" fill={`url(#aria-core-${size})`} />
      <circle cx="30" cy="30" r="1.8" fill="#fff8e0" opacity="0.75" />
    </g>

    {/* Orbital ring A — tilted, spinning forward */}
    <g className="aria-orbit aria-orbit-a">
      <ellipse cx="32" cy="32" rx="26" ry="10" fill="none" stroke={`url(#aria-g1-${size})`} strokeWidth="2" transform="rotate(-28 32 32)" opacity="0.9" />
      <circle cx="55" cy="24" r="2" fill="#e91e63" opacity="0.9" />
    </g>

    {/* Orbital ring B — tilted opposite, spinning reverse */}
    <g className="aria-orbit aria-orbit-b">
      <ellipse cx="32" cy="32" rx="26" ry="10" fill="none" stroke={`url(#aria-g3-${size})`} strokeWidth="2" transform="rotate(28 32 32)" opacity="0.9" />
      <circle cx="10" cy="41" r="1.6" fill="#d4a017" />
    </g>

    {/* Outer halo ring — slow forward spin */}
    <g className="aria-orbit aria-orbit-c">
      <circle cx="32" cy="32" r="20" fill="none" stroke={`url(#aria-g2-${size})`} strokeWidth="1.2" opacity="0.55" strokeDasharray="2 5" />
      <circle cx="40" cy="52" r="1.2" fill="#f5c842" />
    </g>
  </svg>
);

export default LogoMark;
